import React from 'react'

import Icon from 'components/Icon'
import theme from 'theme'

interface PasswordOutcome {
  invalid: boolean
  message: string
}

export const PasswordRules: React.FC<{
  fieldsStyle?: Record<string, React.CSSProperties>
  passwordOutcome: PasswordOutcome[]
}> = ({ fieldsStyle, passwordOutcome }) => (
  <div
    css={{
      marginBottom: theme.space[5],
      textAlign: 'left',
      ...fieldsStyle?.wrapper
    }}
  >
    <div css={{ marginBottom: theme.space[2] }}>
      Please choose a password that meets all of the following:
    </div>
    <ul>
      {passwordOutcome.map(({ invalid, message }, i) => (
        <li
          key={i}
          css={{
            color: invalid ? theme.colors.steel[1] : theme.colors.blue[0],
            listStyleType: 'none',
            marginBottom: theme.space[1]
          }}
        >
          <Icon
            css={{
              width: '0.6rem',
              marginLeft: theme.space[1],
              marginRight: theme.space[3],
              color: invalid ? theme.colors.gray[1] : theme.colors.blue[0]
            }}
            icon={invalid ? 'close' : 'checkmark'}
          />
          {message}
        </li>
      ))}
    </ul>
  </div>
)
